import { useContext } from "react"
import AppInfoContext from "src/provider/state-manager/appInfoProvider"

function SvgComponent(props: any) {
    const {info: {theme}} = useContext(AppInfoContext)

    return (
        <svg
          width={40}
          height={40}
          viewBox="0 0 40 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <rect width={40} height={40} rx={20} fill={theme["#B4E3E1"]} />
          <g clipPath="url(#clip0_4065_9050)">
            <path
              d="M20 16.666v3.333m0 3.334h.009m8.325-3.334a8.333 8.333 0 11-16.667 0 8.333 8.333 0 0116.667 0z"
              stroke={theme["#0D968F"]}
              strokeWidth={1.66667}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_4065_9050">
              <path fill="#fff" transform="translate(10 10)" d="M0 0H20V20H0z" />
            </clipPath>
          </defs>
        </svg>
    )
}
  
  export default SvgComponent